export const UPDATE_TABLE_CONFIG_SUCCESS = 'UPDATE_TABLE_CONFIG_SUCCESS';

export const updateTableConfigSuccess = (tableEntry) => ({
    type: UPDATE_TABLE_CONFIG_SUCCESS,
    payload: { tableEntry },
});
